import {useEffect} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {menu} from "../routes";
import {useFeatureFlags} from "./UseAppData";
import {checkModuleLicense, useLicense} from "./UseLicense";

export function useModuleDisplay() {
    const {curLic} = useLicense();
    const {rsp: ftrFlags} = useFeatureFlags();
    const {hideUnlicensedModules} = ftrFlags?.ff_license || {};

    const isModuleAllowed = (module?: string | string[]) => checkModuleLicense(curLic, module);
    const hasModule = (validate: (has: (module: string) => boolean) => boolean) => checkModuleLicense(curLic, validate);
    const shouldDisplay = (module?: string | string[]) => !hideUnlicensedModules || isModuleAllowed(module);

    return {
        isModuleAllowed,
        hasModule,
        shouldDisplay,
        hideUnlicensedModules
    };
}

export function useCheckModuleRedirect() {
    const {curLic} = useLicense();
    const {rsp: ftrFlags} = useFeatureFlags();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!ftrFlags || !curLic) return;
        const map = buildRoutePermsMap();
        if (!canAccessPathByModule(location.pathname, map, curLic))
            navigate("/");
    }, [location, ftrFlags, curLic]);
}

const getRouteModule = (route: any) => (
    route?.perms?.module ||
    route?.parent?.module
);

const getPathChain = (pathname: string) => {
    const parts = pathname.split("/").filter(Boolean);
    const paths = [];

    for (let i = 0; i < parts.length; i++)
        paths.push("/" + parts.slice(0, i + 1).join("/"));

    return paths;
};

const canAccessPathByModule = (pathname: string, routesConfig: any, curLic: any) => {
    const chain = getPathChain(pathname);

    for (const path of chain) {
        const route = routesConfig[path];
        if (!route) continue;

        const module = getRouteModule(route);
        if (module && !checkModuleLicense(curLic, module))
            return false;
    }

    return true;
};

const buildRoutePermsMap = () => {
    const map: Record<string, any | undefined> = {};

    const walk = (items: any[], parent?: string) => {
        items.forEach(item => {
            if (item.k)
                map[item.k] = {perms: item.perms, parent};

            if (item.subMenu)
                walk(item.subMenu, item.perms);

        });
    };

    walk(menu);
    return map;
};
